import React from 'react'
import { useSelector } from 'react-redux';
import { DataGrid } from '../../components';
import { getLocalized } from '../../redux/localization';
import { adminSliderUrl } from '../../services/urls';
import createSliderForm from './create';
import SliderDetail from "./detail"

const Slider = () => {
    const localize = useSelector(getLocalized);
    const columns = [
        {
            dataField: "Title",
            caption: localize.getString("title"),
        },
        {
            dataField: "Message",
            caption: localize.getString("message"),
        },
        {
            dataField: "Description",
            caption: localize.getString("description"),
        },

        {
            dataField: "ProductCategoryName",
            caption: localize.getString("category"),
        },
    ];
    return (
        <DataGrid
            title='Sliders'
            url={adminSliderUrl}
            getByIdUrl={adminSliderUrl}
            columns={columns || []}
            refObject={{
                File : ""
            }}
            details={{
                width: "70%",
                height: "70%",
                getByIdUrl: adminSliderUrl,
                title: "Slider Detay",
                component: SliderDetail,
            }}
            create={{   
                validationGroup : "createSliderFrom",
                component : createSliderForm,
                width:"50%",
                height : "50%",
                createUrl :adminSliderUrl,
                title : "Slider Ekleme Formu"
                
            }}
            edit={{   
                component : createSliderForm, 
                width:"50%",
                height : "50%",
                editUrl :adminSliderUrl,
                title : "Slider Düzenleme Formu"
                
            }}
            remove={{ url: adminSliderUrl }}

        />
    )
}

export default Slider